const JOURNEY_TOKEN_KEY = "journeyToken";
const RESPONDENT_TOKEN_KEY = "respondentToken";

export class SessionUtils {
  static getJourneyToken() {
    return sessionStorage.getItem(JOURNEY_TOKEN_KEY) || "";
  }

  static setJourneyToken(token) {
    if (token) sessionStorage.setItem(JOURNEY_TOKEN_KEY, token);
  }

  static getRespondentToken() {
    return sessionStorage.getItem(RESPONDENT_TOKEN_KEY) || "";
  }

  static setRespondentToken(token) {
    if (token) sessionStorage.setItem(RESPONDENT_TOKEN_KEY, token);
  }
}
